export default {
  title: 'Code promo',
  fields: {
    preset: {
      label: 'Préréglage',
    },
    presets: {
      master: 'Maître',
      campaign: 'Campagne',
      one_time: 'Usage unique',
    },
    code: {
      label: 'Code',
      placeholder: 'Saisir le code',
    },
    discount_type: {
      label: 'Type de remise',
    },
    quantity: {
      label: 'Quantité',
      placeholder: 'Illimité',
    },
    expires_at: {
      label: "Date d'expiration",
      placeholder: 'Saisir une date ou laisser vide',
    },
    franchise: {
      label: 'Code promo principal pour le restaurant et/ou pour toute la marque',
    },
    discount: {
      label: 'Remise',
    },
    usage_threshold: {
      label: "Seuil d'utilisation",
    },
  },
  messages: {
    master_warning: "La création d'un nouveau code promo « maître » expirera le code promo maître actuel",
  },
  buttons: {
    save: 'Enregistrer',
    cancel: 'Annuler',
  },
  toasts: {
    promo_code_got_created: 'Code promo créé',
    promo_code_got_updated: 'Code promo mis à jour',
  },
};
